interface DashOrNumOptions {
  precision: number;
  empty: string;
}

export function dashOrNum(
  value: number | string | null | undefined,
  options: Partial<DashOrNumOptions> = {}
): string {
  const actualOptions: DashOrNumOptions = {
    precision: 2,
    empty: "-",
    ...options,
  };

  if (typeof value === "string") {
    value = parseFloat(value);
  }

  return value !== null && value !== undefined
    ? value.toFixed(actualOptions.precision)
    : actualOptions.empty;
}

export function humanFileSize(bytes: number) {
  if (bytes === 0) {
    return "0.00 B";
  }
  const e = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, e)).toFixed(2) + " " + " KMGTP".charAt(e) + "B";
}
